import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getEnvironments } from '../api/documentAPI';
import '../css/pages/documents.css';

import useAuth from "../hooks/useAuth";
import DocumentsList from '../components/docs/DocumentsList';
import Uploader from '../components/docs/Uploader';
import EnvironmentsList from '../components/docs/EnvironmentsList';

const ManageDocuments = ({ }) => {
    const { auth } = useAuth();
    const navigate = useNavigate();
    const [t, ] = useTranslation('global');
    const [selectedEnvId, setSelectedEnvId] = useState(null);

    const handleEnvItemClick = (id) => {
        setSelectedEnvId(id);
    }

    const handleGoBack = () => {
        navigate('/');
    };

    const fetchInitialData = () => {
         if(selectedEnvId === null) {
            getEnvironments()
            .then((data) => {
                setSelectedEnvId(data[0].Id);
            });
        }
    };

    useEffect(() => {
        if (auth.uri === 1) {
            fetchInitialData();
        } else {
            navigate('/Unauthorized'); 
        }
    }, []); 

    return (
        <>
        <div className='documents-wrap'>
            <div className="header-title">
                <h1>{t('manageDocs')}</h1>
            </div>   

            <div className='table-wrapper'>              
                <div className='list-wrapper'>
                    <div id="manage-docs">                      
                    <h3>{t('environments')}</h3>
                        <EnvironmentsList 
                            onEnvItemClick={handleEnvItemClick} 
                        />
                        {selectedEnvId && 
                            <DocumentsList 
                                id={selectedEnvId} 
                            />
                        }
                    </div>
                </div>
                <div className='upload-wrapper'>
                    {selectedEnvId && 
                        <Uploader id={selectedEnvId}/> 
                    }
                </div>
            </div>
            <button className="return-button" onClick={handleGoBack}>{t('return')}</button>
        </div>
        </>        
    );
}

export default ManageDocuments;